module.exports = __webpack_public_path__ + "img/ios_user.222d405b.png";